export const SMS_TYPE_TOOLTIP_ID = 'id-type-of-the-SMS-tooltip';

export const INFORMATION_FOR_PARTICIPANT_LABEL_ID =
  'id-information-for-participant-label';

export const ALERT_FOR_THIRD_PARTY_LABEL_ID = 'id-alert-for-third-party-label';
